export const pathWithId = (path: string, id: string) => {
	return path.replace('{id}', id);
};

export const cleanPath = (path: string | number): string => `${path}`.replace(/^\/+|\/+$/g, '');

export const buildURL =
	(base = '') =>
	(...paths: (string | number)[]): string =>
		[base, ...paths].map(cleanPath).join('/');
